 

const state = {
 
	bgSetting: true,
	districtstate: null,
}

export default state